import { AxiosError } from '@ori/axios';
import { FetchGraphqlError } from './FetchGraphqlError';

/**
 * Error that indicates that fetch to graphql server was successful, but had empty response
 */
export class EmptyBodyFetchGraphqlError extends FetchGraphqlError {
  constructor(response, query) {
    const message = 'Empty body returned from GraphQl server';
    // eslint-disable-next-line unicorn/custom-error-definition -- okay in this case
    super(new AxiosError(message, AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response), query);
    this.name = 'EmptyBodyFetchGraphqlError';
    this.message = message;
  }
}
//# sourceMappingURL=EmptyBodyFetchGraphqlError.js.map